export const Settings_LineTypeFilter = "Rewind365.Modules.DynamicsBc.DeLux.LineTypeFilter";
export const Settings_DirectCostsEnabled = "Rewind365.Modules.DynamicsBc.DeLux.DirectCostsEnabled";